@if (
  (isProfilerFeatureSelected$ | async) &&
  !isProfileStatusSucceded() &&
  (getProfilerLibraryId$ | async) !== 0
  ) {
  <div
    class="status-screen mat-app-background"
    matRaised
    >
    <span class="header" i18n="@@creatingProfile">Creating Profile</span>
    <mat-divider></mat-divider>
    <atlas-profiler-progress
      [progressSteps]="getProgressSteps$ | async"
      [importStatusErrors]="getImportStatusErrors$ | async"
    ></atlas-profiler-progress>
    @if (isErrorOccured() | async) {
      <div>
        <button class="cancel-button" (click)="onCancelClicked()">
          <span i18n="@@cancelButton">Cancel</span>
        </button>
      </div>
    }
  </div>
}
